// Vendor Libs
import React from 'react';

// Components
import {get} from 'lodash';
import Permissions from '../core/permissions';
import DisplayPathModifierForm from './display-path-modifier-form';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createDisplayPathModifier';

function CreateDisplayPathModifier() {
    return (
        <Permissions
            accessRequirement="create"
            elementService="networkDisplayPathModifier"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            <FormData formName={formName}>
                {({ formData, locallyLocked, lockedRecords, resetForm, setFieldValue }) => (
                    <DisplayPathModifierForm
                        className="create-display-path-modifier"
                        formData={formData}
                        formName={formName}
                        setFieldValue={setFieldValue}
                        lockedNetworkOfDisplayPathModifier={getlockedNetworkByOtherUsersForDisplayPathModifier(
                      lockedRecords,
                      locallyLocked
                        )}
                        onReset={resetForm}
                    />
                )}
            </FormData>
        </Permissions>
    );
}

const getLocallyLockedNetwork = (locallyLocked) => get(locallyLocked, 'displayPathModifier', []);

const getlockedNetworkByOtherUsersForDisplayPathModifier = (lockedRecords, locallyLocked) =>
    get(lockedRecords, 'displayPathModifier', [])
        .filter((lockedRecord) => !getLocallyLockedNetwork(locallyLocked).includes(lockedRecord.recordId))
        .map((lockedRecord) => lockedRecord.recordId);

export default CreateDisplayPathModifier;
